<template>
  <div>
    <Head :title="form.name" />
    <h1 class="mb-8 text-3xl font-bold noprint">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/purchaseorders">Purchase Orders</Link>
      <span class="text-indigo-400 font-medium"> /</span>
      #{{ pad(purchaseorder.id) }} <button @click="makePDF"><icon name="printer" class="mr-2 w-4 h-4" :class="'fill-indigo-400 group-hover:fill-white'" /></button>
    </h1>
    <h1 class="onlyprint">PO #{{ pad(purchaseorder.id) }}</h1>
    <trashed-message v-if="purchaseorder.deleted_at" class="mb-6" @restore="restore"> This PO has been deleted. </trashed-message>
    <div class="max-w-5xl bg-white rounded-md shadow overflow-hidden" id="ordercontainer">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <div class="pb-4 pr-6 w-1/2">
            <div class="w-full">Vendor:<br/><br/>
              <SelectInput  id="vendor" class="mb-4 w-full" v-model="form.vendor" disabled="disabled" >
                <option value="0">None (CarbonMark)</option>
                <option v-for="vendor in this.vendors.data" :value="vendor.id"> {{ vendor.vendorname }}</option>
              </SelectInput>
            </div>
            <div class="w-full">PO Type:<br/><br/>
            <SelectInput id="ordertype" class="mb-4 w-full" v-model="form.ordertype" disabled="disabled" >
                <option v-for="ot in OrderTypes" :value="ot" :class="'potype-' + ot + ' nohide'">{{ ot }}</option>
            </SelectInput>

             <text-input v-show="form.ordertype == 'TRUSS'" v-model="form.building" :error="form.errors.building" class="pb-4 w-1/3" label="Building" placeholder="1 (Type 1)" />
             <text-input v-show="form.ordertype == 'TRUSS'" v-model="form.floor" :error="form.errors.floor" class="pb-4 w-1/3" label="Floor" placeholder="Roof" />
            
          </div>
          Ship To: <SelectInput class="p-2 w-full" disabled="disabled" id="orderjobsite" v-model="form.jobsite_id"><option>--Select a Jobsite--</option><option v-for="jobsite in this.jobsites.data" :value="jobsite.id">{{jobsite.sitename}}</option></SelectInput><br/><br/>
          <!--<textarea :error="form.errors.shipto" rows="5" disabled="disabled" class="mb-4 ml-0 p-2 w-full bg-gray-300" label="S\hip To" v-model="form.shipto" ></textarea>-->
          </div>

          <div class="pb-4 pr-6 w-1/2"><!-- Sold To:<br/><br/>-->
             <textarea :error="form.errors.soldto" rows="5" class="mb-4 ml-0 p-2 w-full bg-gray-300 hide " label="Sold To" v-model="form.soldto" placeholder=""></textarea>
             <span>Category/Type Totals:</span><br/>&nbsp;<br/>
             <div>WoodTruss: &nbsp; <span id="woodtrussqty">-</span></div><br/>
             <div>WoodFloor: &nbsp; <span id="woodfloorqty">-</span></div><br/>
             <div>EWP:&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; <span id="ewpqty">-</span></div><br/>
             <div>Hardware: &nbsp; &nbsp;<span id="hardwareqty">-</span></div>
          </div>

          <!--<div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Projected Delivery: </div>
            <datepicker v-model="form.projected_delivery" :enableTimePicker="false" autoApply :error="form.errors.projected_delivery" class="pb-4 pr-2" label="Projected Delivery"/>
          </div>-->

          <!--<div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Actual Delivery: </div>
            <datepicker v-model="form.actual_delivery" :enableTimePicker="false" autoApply :error="form.errors.actual_delivery" class="pb-4 pr-2" label="Actual Delivery"/>
          </div>-->


          <div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">PO Date: </div>
            <datepicker v-model="form.order_date" :enableTimePicker="false" autoApply :error="form.errors.order_date" class="pb-4 pr-2 " label="Order Date" />
          </div>


          <div class="pb-4 pr-4 w-1/4">
            <div class="mb-2">Cutoff Date: </div>
            <datepicker v-model="form.cutoff_date" :enableTimePicker="false" autoApply :error="form.errors.cutoff_date" class="pb-4 pr-2" label="Cutoff Date" />
          </div>

         
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-4 pr-6 w-1/4" label="Phone" placeholder="(254) 111-1111" />
          <text-input v-model="form.fob" :error="form.errors.fob" class="pb-4 pr-6 w-1/4" label="F.O.B." placeholder="Jobsite" />
          <text-input v-model="form.trader" :error="form.errors.trader" class="pb-4 pr-6 w-1/4" label="Trader" placeholder="" />
          <text-input v-model="form.payment_terms" :error="form.errors.payment_terms" class="pb-4 pr-6 w-1/4" label="Payment Terms" placeholder="NET30" />
          <text-input v-model="form.routing" :error="form.errors.routing" class="pb-4 pr-6 w-1/4" label="Routing" placeholder="Truck" />
          <text-input v-model="form.bid_id" :error="form.errors.bid_id" class="pb-4 pr-6 w-1/4" label="Bid ID" placeholder="" />

          <div class="w-full mb-4 pr-6">
            <h2 class="mb-4 text-2xl font-bold">Items</h2> 
            <div id="orderstable" class=""></div>
            <button v-if="(form.status < 5)" class="signature-button p-2 mb-2 bg-yellow-200 font-bold noprint" @click="addRow">Add Row</button>
            <button v-if="(form.status < 5)" class="signature-button p-2 mb-2 bg-yellow-200 font-bold noprint" @click="importRows">Import</button>            
            <text-input v-show="true" v-model="form.products" id="productsdata" :error="form.errors.products" />
            
          </div>
          <div class="w-full nobreak">
            <h2 class="mb-4 text-2xl font-bold">Signature</h2>
            <Vue3Signature  ref="signature1" :sigOption="state.option" :w="'auto'" :h="'200px'" 
                :disabled="state.disabled" :defaultUrl="(form.signature ? form.signature : '')" class="pr-6 nobreak"></Vue3Signature>
            <button v-show="form.status < 5" class="signature-button p-2 mb-8 bg-yellow-200 font-bold noprint" @click="clear">Clear</button>&nbsp; 
            <button v-show="form.status < 5" class="signature-button p-2 mb-8 bg-green-200 font-bold noprint" @click="save">Save</button>&nbsp; 
            <text-input v-show="true" v-model="form.signature" id="signaturedata" :error="form.errors.signature" />
          </div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">

          <input type="number" v-model="form.status" style="display:none!;" id="orderstatus" class="hide hidden" v-show="false" />
          <!--<input type="number" v-model="form.ordertype" style="display:none!;" id="ordertype" class="hide hidden" v-show="false" />-->

          <button v-if="((!purchaseorder.deleted_at) && (auth.user.role == 'ADMIN') && (form.status < 5))" class="text-red-600 hover:underline noprint" tabindex="-1" type="button" @click="destroy">Delete PO</button>
          <loading-button v-if="(form.status < 5 && (auth.user.role == 'ADMIN'))" :loading="form.processing" class="btn-indigo ml-auto noprint" type="submit">Save PO</loading-button>
          <button v-if="((auth.user.role == 'ADMIN') && (form.status == 5))" class="btn-indigo font-bold ml-auto noprint" @click="form.status = 0; finalize();">Unfinalize (ADMIN ONLY)</button>
          <button v-if="((auth.user.role == 'ADMIN') && (form.status < 5))" class="btn-indigo font-bold ml-auto noprint" @click="form.status = 5; finalize();">Finalize PO</button>
        </div>
      </form>
    </div>
  </div>
  <div id="updatejobsite"></div>
</template>
<style>
#productsdata, #signaturedata { display:none; }
.onlyprint { display:none; }
.hide { display:none !important; }
/* PRINT */
@media print {
  .onlyprint { display:initial; }
  .noprint, #mainmenu { display:none; }
  * { border:0px solid #FFF !important; }
  #ordercontainer {box-shadow:none !important; }
  .nobreak, .nobreak canvas, .nobreak * { page-break-inside: avoid; }
  svg.dp__icon { display:none; }
  .tabulator-cell svg { display:none; }
}
</style>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { TabulatorFull as Tabulator } from 'tabulator-tables'
import {InteractionModule} from 'tabulator-tables'
import Vue3Signature from "vue3-signature"
import { Input } from 'postcss'
import NProgress from 'nprogress'
import { booleanLiteral } from '@babel/types'
//import { table } from 'console'
import { jsPDF } from "jspdf";
import {
  OrderTypes,
} from "./../../../enums";


export default {
  mounted() {
    //window.setTimeout(function() {  },100);
    //this.checkOrderTypes();
  },
  setup(props) {},
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Datepicker,
    Tabulator,
    OrderTypes,
  },
  layout: Layout,
  props: {
    purchaseorder: Object,
    jobsites: Object,
    auth: Object,
    vendors: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        sitename: this.purchaseorder.sitename,
        phone: this.purchaseorder.phone,
        soldto: this.purchaseorder.soldto,
        shipto: "The Josephine\r\n210 West Josephine St\r\nSan Antonio TX 78212",
        order_date: this.purchaseorder.order_date,
        projected_delivery: this.purchaseorder.projected_delivery,
        cutoff_date: this.purchaseorder.cutoff_date,
        actual_delivery: this.purchaseorder.actual_delivery,
        payment_terms: this.purchaseorder.payment_terms,
        trader: this.purchaseorder.trader,
        fob: this.purchaseorder.fob,
        routing: this.purchaseorder.routing,
        bid_id: this.purchaseorder.bid_id,
        products: this.purchaseorder.products,
        signature: this.purchaseorder.signature,
        status: this.purchaseorder.status,
        jobsite_id: this.purchaseorder.jobsite_id,
        ordertype: this.purchaseorder.ordertype,
        building: this.purchaseorder.building,
        floor: this.purchaseorder.floor,
        vendor: this.purchaseorder.vendor,
      }),
      jsondata: JSON.parse(this.purchaseorder.products),
    }
  },
  methods: {
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    checkOrderTypes() {
      try {
        var vends = this.vendors.data;
        var thisv;
        vends.forEach((v,k) => {
          if (parseInt(v.id) == parseInt(this.purchaseorder.vendor)) {
            thisv = v;
          }
        })
        document.querySelectorAll('#ordertype option').forEach((v,k) => {
          v.classList.add('hide');
        });
        var ots = JSON.parse(thisv.ordertypes);
        Object.values(ots).forEach((v,k) => {
          var cl = (document.querySelector('.potype-' + v)) ? document.querySelector('.potype-' + v).classList : '';
          if (cl) { cl.remove('hide'); }
        });
        //window.setTimeout(function() { document.querySelector('#ordertype').selectedIndex = -1; },1 );
        //window.setTimeout(function() { document.querySelectorAll('#ordertype option:not(.hide)')[0].selected = true; },50 );
        
      } catch(e) { console.warn(e); }
    },
    savesig() {
      event.preventDefault();
      var nv = this.signature1.save();
      this.purchaseorder.signature = nv;
      this.form.signature = nv;
    },
    saveitems() {
      event.preventDefault();
      this.purchaseorder.products = this.tabledata;
      this.form.products = this.tabledata;
    },
    update() {
      event.preventDefault();
      if (document.querySelector('#productsdata').value.length > 0) {
        var storedata = JSON.parse(document.querySelector('#productsdata').value);
        this.purchaseorder.products = JSON.stringify(storedata);
        this.form.products = JSON.stringify(storedata);
      } else { console.error(' Tabledata failure ')}

      this.purchaseorder.signature = document.querySelector('#signaturedata').value;
      this.form.signature = document.querySelector('#signaturedata').value;

      this.form.put(`/purchaseorders/${this.purchaseorder.id}`);
    },
    finalize() {
      event.preventDefault();
      if (document.querySelector('#productsdata').value.length > 0) {
        var fixtdata = JSON.parse(document.querySelector('#productsdata').value);
        this.purchaseorder.products = JSON.stringify(fixtdata);
        this.form.products = JSON.stringify(fixtdata);
        //this.tabledata = fixtdata;
      } else { console.error(' Tabledata failure ')}

      
      this.purchaseorder.signature = document.querySelector('#signaturedata').value;
      this.form.signature = document.querySelector('#signaturedata').value;
      
      this.form.put(`/purchaseorders/${this.purchaseorder.id}`);
    },
    destroy() {
      if (confirm('Are you sure you want to delete this order?')) {
        this.$inertia.delete(`/purchaseorders/${this.purchaseorder.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this order?')) {
        this.$inertia.put(`/purchaseorders/${this.purchaseorder.id}/restore`)
      }
    },
    pad(n) {
      return n.toString().padStart(5,"0");
    },
   /* PDF */
    makePDF() {
      event.preventDefault();
      window.print();
      /*
      // Default export is a4 paper, portrait, using millimeters for units
      const doc = new jsPDF();


      doc.html(document.getElementsByTagName('form'), {
        callback: function (doc) {
          doc.save();
        },
        x: 10,
        y: 10
      });
      */
    },
  },
}
</script>


<script setup>
import {reactive, ref} from 'vue'


const state = reactive({
  count: 0,
  option: {
    penColor: "rgb(0, 0, 0)",
    backgroundColor: "rgb(242,242,242)"
  },
  disabled: false,
})

  const signature1 = ref(null);

  const save = (t) => {
    event.preventDefault();
    var nv = signature1.value.save('image/svg+xml');
    document.querySelector('#signaturedata').value = nv;
    //form.signature = nv;
    return nv;
    //this.save2(saveval);
  }
  
  const clear = () => {
    event.preventDefault();
    document.querySelector('#signaturedata').value = '';
    signature1.value.clear()
  }

const undo = () => {
  event.preventDefault();
  signature1.value.undo();
}

const addWaterMark = () => {
  event.preventDefault();
  signature1.value.addWaterMark({
    text: "mark text",          // watermark text, > default ''
    font: "20px Arial",         // mark font, > default '20px sans-serif'
    style: 'all',               // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
    fillStyle: "red",           // fillcolor, > default '#333'
    strokeStyle: "blue",	       // strokecolor, > default '#333'
    x: 100,                     // fill positionX, > default 20
    y: 200,                     // fill positionY, > default 20
    sx: 100,                    // stroke positionX, > default 40
    sy: 200                     // stroke positionY, > default 40
  });
}

const fromDataURL = (url) => {
  event.preventDefault();
  signature1.value.fromDataURL(url);
}

const handleDisabled = () => {
  //event.preventDefault();
  state.disabled = !state.disabled
}

const addRow = () => {
    event.preventDefault();
    Table.addData([{itemdesc:'', price:0, quantity:0, unit: ''}])
};

const importRows = () => {
  Table.import("csv", "/josephine-data-import.csv")
};

const calcCatTotals = (tabledata) => {
  var cwoodtrussqty = 0;
  var cwoodfloorqty = 0;
  var cewpqty = 0;
  var chardwareqty = 0;
  tabledata.forEach(function(v,k) {
    if (v.itemcategory == "WoodTruss") { cwoodtrussqty += parseInt(v.quantity);}
    if (v.itemcategory == "WoodFloor") { cwoodfloorqty += parseInt(v.quantity);}
    if (v.itemcategory == "EWP") { cewpqty += parseInt(v.quantity);}
    if (v.itemcategory == "Hardware") { chardwareqty += parseInt(v.quantity);}
  });
  document.querySelector('#woodtrussqty').textContent = cwoodtrussqty;
  document.querySelector('#woodfloorqty').textContent = cwoodfloorqty;
  document.querySelector('#ewpqty').textContent = cewpqty;
  document.querySelector('#hardwareqty').textContent = chardwareqty;
};

var tabledata;
var Table;

window.setTimeout(function() {

  
  var formstatus = parseInt(document.querySelector("#orderstatus").value);
  var ordertyper = document.querySelector("#ordertype").value;

  var columnsRead = [
    {title:"id",field:"id",formatter:"rownum",headerSort:false},  
    {title:"Qty",field:"quantity",headerSort:false},
    {title:"Unit",field:"unit",headerSort:false},
    {title:"T",field:"sizet",headerSort:false},
    {title:"W",field:"sizew",headerSort:false},
    {title:"L",field:"sizel",headerSort:false},
    {title:"Item",field:"itemdesc",headerSort:false},
    {title:"Tot Qty",field:"totalqty",headerSort:false},
    {title:"Tot Unit",field:"totalunit",headerSort:false},
    {title:"Category",field:"itemcategory",headerSort:false},
  ];

  var columnsWrite = [
    {title:"id",field:"id",formatter:"rownum",headerSort:false},  
    {title:"Qty",field:"quantity",editor:"number",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
    {title:"Unit",field:"unit",editor:"input",headerSort:false},
    {title:"T",field:"sizet",editor:"input",headerSort:false},
    {title:"W",field:"sizew",editor:"input",headerSort:false},
    {title:"L",field:"sizel",editor:"input",headerSort:false},
    {title:"Item",field:"itemdesc",editor:"input",headerSort:false},
    {title:"Tot Qty",field:"totalqty",editor:"number",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
    {title:"Tot Unit",field:"totalunit",editor:"input",headerSort:false},
    {title:"Category",field:"itemcategory",editor:"input",headerSort:false},
    {title:"",formatter:"buttonCross", width:40, editable:true, editor:true, headerSort:false, hozAlign:"center", cellClick:function(e, cell){window.setTimeout(function() { cell.getRow().delete(); },5); }},
  ];

  if (ordertyper == 'TRUSS') {
    columnsRead = [
      {title:"id",field:"id",formatter:"rownum",headerSort:false},  
      {title:"Qty",field:"quantity",editor:"number",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
      {title:"Span/L",field:"span",editor:"input",headerSort:false},
      {title:"Desc",field:"description",editor:"input",headerSort:false},
      {title:"TC Pitch",field:"tcpitch",editor:"input",headerSort:false},
      {title:"BC Pitch",field:"bcpitch",editor:"input",headerSort:false},
      {title:"TC Size",field:"tcsize",editor:"input",headerSort:false},
      {title:"BC Size",field:"tcsize",editor:"input",headerSort:false},
      {title:"Weight",field:"weight",editor:"input",headerSort:false},
      {title:"Weight2",field:"weight2",editor:"input",headerSort:false},
      {title:"Truss H",field:"trussheight",editor:"input",headerSort:false},
      {title:"Ship H",field:"shipheight",editor:"input",headerSort:false},
      {title:"Cat/Type",field:"itemcategory",editor:"input",headerSort:false},
      {title:"Section",field:"section",editor:"input",headerSort:false},

    ];
    columnsWrite = [
      {title:"id",field:"id",formatter:"rownum",headerSort:false},  
      {title:"Qty",field:"quantity",editor:"number",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
      {title:"Span/L",field:"span",editor:"input",headerSort:false},
      {title:"Desc",field:"description",editor:"input",headerSort:false},
      {title:"TC Pitch",field:"tcpitch",editor:"input",headerSort:false},
      {title:"BC Pitch",field:"bcpitch",editor:"input",headerSort:false},
      {title:"TC Size",field:"tcsize",editor:"input",headerSort:false},
      {title:"BC Size",field:"tcsize",editor:"input",headerSort:false},
      {title:"Weight",field:"weight",editor:"input",headerSort:false},
      {title:"Weight2",field:"weight2",editor:"input",headerSort:false},
      {title:"Truss H",field:"trussheight",editor:"input",headerSort:false},
      {title:"Ship H",field:"shipheight",editor:"input",headerSort:false},
      {title:"Cat/Type",field:"itemcategory",editor:"input",headerSort:false},
      {title:"Sect.",field:"section",editor:"input",headerSort:false},
      {title:"",formatter:"buttonCross", width:40, editable:true, editor:true, headerSort:false, hozAlign:"center", cellClick:function(e, cell){window.setTimeout(function() { cell.getRow().delete(); },5); }},
    ];
  }
  
  if (ordertyper == 'HARDWARE') {
    columnsRead = [
      {title:"id",field:"id",formatter:"rownum",headerSort:false},  
      {title:"Qty",field:"quantity",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
      {title:"Unit",field:"unit",headerSort:false},
      {title:"Item",field:"itemdesc",headerSort:false},
      {title:"Mfg",field:"mfg",headerSort:false},
      {title:"Cost",field:"unitcost",headerSort:false},
    ];

    columnsWrite = [
      {title:"id",field:"id",formatter:"rownum",headerSort:false},  
      {title:"Qty",field:"quantity",editor:"number",editorParams:{min:0,max:9999999999,step:1},headerSort:false},
      {title:"Unit",field:"unit",editor:"input",headerSort:false},
      {title:"Item",field:"itemdesc",editor:"input",headerSort:false},
      {title:"Mfg",field:"mfg",editor:"input",headerSort:false},
      {title:"Cost",field:"unitcost",editor:"input",headerSort:false},
      //{title:"Category",field:"itemcategory",editor:"input",headerSort:false},
      {title:"",formatter:"buttonCross", width:40, editable:true, editor:true, headerSort:false, hozAlign:"center", cellClick:function(e, cell){window.setTimeout(function() { cell.getRow().delete(); },5); }},
    ];
  }
  
  Table = new Tabulator("#orderstable", {
    reactiveData:false, //enable reactive data
    data:this.tabledata,
    columns: (formstatus == 5 ? columnsRead : columnsWrite),
  });

  
  Table.on("cellEdited", function(cell) {
    tabledata = Table.getData();
    calcCatTotals(tabledata);
    document.querySelector('#productsdata').value = JSON.stringify(tabledata);
  });

    
  window.setTimeout(function() {
    var pdval = document.querySelector('#productsdata').value;
    if ((typeof(pdval) !== 'undefined') && (pdval.length > 0)) {
      Table.replaceData(JSON.parse(document.querySelector('#productsdata').value)).then(calcCatTotals(JSON.parse(document.querySelector('#productsdata').value)));
    }
  },1);


  if (parseInt(document.querySelector("#orderstatus").value) == 5) { handleDisabled(); }


},200);

</script>